import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

interface HeaderLocationTapEventProps {
  sourcePage: SourcePages;
}

export default function HeaderLocationTapEvent({
  sourcePage,
}: HeaderLocationTapEventProps): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature: Features.srpHeader,
    engagement_type: `location_tap`,
  };
}
